import { getAssetPath, h } from '@stencil/core';

import wcShared from '@web-components/shared';

export const Cancel = ({
  showConfirm = false,
  cancel,
}: {
  showConfirm: boolean;
  cancel: () => void;
}) => {
  return (
    <div class="cancel">
      <div class="left">
        <h1>
          {showConfirm
            ? wcShared?.translate(
                'Souhaitez-vous annuler la demande de rappel par notre agent du support ?',
              )
            : wcShared?.translate('Votre demande de rappel a bien été annulé')}
        </h1>
        {showConfirm ? (
          <button onClick={cancel}>{wcShared?.translate('Confirmer')}</button>
        ) : (
          <p>
            {wcShared?.translate(
              'Si votre problème persiste, n’hésitez pas à planifier un rappel ou contacter directement nos agents du support.',
            )}
          </p>
        )}
      </div>
      <img
        alt="group logo svg"
        src={getAssetPath('./../assets/icons/group-yellow.svg')}
      />
    </div>
  );
};
